module.exports = __webpack_public_path__ + "static/img/info2.d4c50b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/pic/info2.jpg
// module id = l4sq
// module chunks = 11